import { render, staticRenderFns } from "./additionalFilesUpload.vue?vue&type=template&id=371824c8&scoped=true"
import script from "./additionalFilesUpload.vue?vue&type=script&lang=js"
export * from "./additionalFilesUpload.vue?vue&type=script&lang=js"
import style0 from "./additionalFilesUpload.vue?vue&type=style&index=0&id=371824c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "371824c8",
  null
  
)

export default component.exports